import { Link } from "wouter";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Section, PageHeader, Eyebrow } from "@/components/Section";
import { AustraliaCallout } from "@/components/AustraliaCallout";
import { INDUSTRIES, GENERIC_INDUSTRY } from "@/lib/industries";

export default function IndustriesIndex() {
  return (
    <>
      <Seo
        title="Industries we serve"
        description="FortifyID protects any business that captures bank, contact or instruction changes from clients — real estate, conveyancing, legal, payroll, accounting, insurance and beyond."
        path="/industries"
      />
      <Section>
        <PageHeader
          eyebrow="Industries"
          title="Wherever you collect sensitive client details."
          lede="FortifyID gives you one verified, audit-ready flow for any change request — bank accounts, contact details, addresses, instructions — from owners, clients, employees, beneficiaries, anyone you have an ongoing relationship with."
        />
      </Section>
      <Section className="!pt-0">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[hsl(var(--brand-sand))] border border-[hsl(var(--brand-sand))] rounded-xl overflow-hidden">
          {INDUSTRIES.map((i) => (
            <Link
              key={i.slug}
              href={`/industries/${i.slug}`}
              className="bg-[hsl(var(--brand-bone))] p-6 sm:p-8 hover:bg-white transition-colors group"
              data-testid={`card-industry-${i.slug}`}
            >
              <Eyebrow>{i.name}</Eyebrow>
              <p className="mt-3 text-[hsl(var(--brand-charcoal))] leading-relaxed">
                {i.shortBlurb}
              </p>
              <div className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-[hsl(var(--brand-forest))] group-hover:gap-2 transition-all">
                Read more <ArrowRight className="w-4 h-4" />
              </div>
            </Link>
          ))}
        </div>
      </Section>
      <Section className="!pt-0">
        <div className="rounded-2xl border border-[hsl(var(--brand-sand))] bg-white/50 p-6 sm:p-10 grid md:grid-cols-3 gap-8 items-start">
          <div>
            <Eyebrow>Other industries</Eyebrow>
            <h2 className="mt-3 text-2xl font-semibold text-[hsl(var(--brand-charcoal))]">
              Don't see yours?
            </h2>
          </div>
          <div className="md:col-span-2 space-y-4 text-[hsl(var(--brand-slate))] leading-relaxed">
            <p>
              {GENERIC_INDUSTRY.heroSub} NDIS providers, super funds, brokers, mortgage originators,
              franchise networks — the verified change-request flow is the same.
            </p>
            <Link
              href="/industries/generic"
              className="inline-flex items-center gap-1 text-sm font-medium text-[hsl(var(--brand-forest))] hover:underline"
              data-testid="link-industry-generic"
            >
              Generic outbound payments & sensitive details <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </Section>
      <Section className="!pt-0">
        <AustraliaCallout />
      </Section>
    </>
  );
}
